import { render, staticRenderFns } from "./handpickArticlePicList.vue?vue&type=template&id=b96c8794&scoped=true&"
import script from "./handpickArticlePicList.vue?vue&type=script&lang=js&"
export * from "./handpickArticlePicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96c8794",
  null
  
)

export default component.exports